export const RELATED_VIDEOS_REQUEST = Symbol('RELATED_VIDEOS_REQUEST');
export const RELATED_VIDEOS_SUCCESS = Symbol('RELATED_VIDEOS_SUCCESS');
export const RELATED_VIDEOS_IQS_REQUEST = Symbol('RELATED_VIDEOS_IQS_REQUEST');
export const RELATED_VIDEOS_IQS_SUCCESS = Symbol('RELATED_VIDEOS_IQS_SUCCESS');
export const RELATED_VIDEOS_RESET = Symbol('RELATED_VIDEOS_RESET');

export const relatedVideosRequestAction = (videoId, pageNumber = 1, previousVideos = []) => ({
  type: RELATED_VIDEOS_REQUEST,
  payload: {
    videoId,
    pageNumber,
    previousVideos,
  },
});

export const relatedVideosSuccessAction = (videos, total, pageNumber, perPage) => ({
  type: RELATED_VIDEOS_SUCCESS,
  payload: {
    videos,
    total,
    pageNumber,
    perPage,
  },
});

export const relatedVideosIqsRequestAction = (videoId, pageCursor = '', previousVideos = []) => ({
  type: RELATED_VIDEOS_IQS_REQUEST,
  payload: {
    videoId,
    pageCursor,
    previousVideos,
  },
});

export const relatedVideosIqsSuccessAction = (videos, total, pageCursor, pageSize) => ({
  type: RELATED_VIDEOS_IQS_SUCCESS,
  payload: {
    videos,
    total,
    pageCursor,
    pageSize,
  },
});

export const relatedVideosResetAction = () => ({ type: RELATED_VIDEOS_RESET });
